import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { errorToast, successToast, warningToast } from "components/toast/toast";
import { LOAD_SAVINGSACCOUNT, LOAD_WALLET } from "GraphQL/Queries";
import { useQuery } from "@apollo/client";

export default function CheckoutForm({
  amount,
  email,
  phoneNumber,
  name,
  paymentDetails,
  setFundsConfirmed,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const getWallet = useQuery(LOAD_WALLET);
  const getVault = useQuery(LOAD_SAVINGSACCOUNT);

  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsProcessing(true);

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: "if_required",
      confirmParams: {
        // Use the 'if_required' value for the redirect option.
        return_url: `${window.location.origin}`,
      },
    });

    if (error) {
      setMessage(error?.message);
      errorToast("Error", error?.message);
    } else if (paymentIntent) {
      // Handle the successful payment confirmation.
      successToast("Success", "Payment Successful");

      setFundsConfirmed({
        status: true,
        amount: parseInt(paymentIntent.amount) / 100,
      });

      getWallet.refetch([{ query: LOAD_WALLET }]);
      getVault.refetch([{ query: LOAD_SAVINGSACCOUNT }]);
    } else {
      setMessage("An unexpected error occured.");
      errorToast("Error", "An unexpected error occured.");
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button
        disabled={isProcessing || !stripe || !elements}
        id="submit"
        className="bg-yellow-500 rounded-[8px] text-white-100 border-none px-4 py-3 mt-4 font-semibold cursor-pointer transition duration-200 ease-in block hover:contrast-[115%] active:brightness-90 disabled:cursor-none disabled:opacity-50"
      >
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && (
        <div className="mt-2 text-red-700" id="payment-message">
          {message}
        </div>
      )}
    </form>
  );
}
